import * as React from 'react';

import { Form } from '@independent-software/typeui/controls/Form';
import { Dialog } from '@independent-software/typeui/controls/Dialog';
import { Panel } from '@independent-software/typeui/controls/Panel';
import { DataTable } from '@independent-software/typeui/controls/DataTable';
import { Checkbox } from '@independent-software/typeui/controls/Checkbox';

import { Parameter, ParameterFactory } from '../../resource/'; 
import { List, IListState, IListProps, SearchFilter } from '../../services/';
import { IconBar, Export } from '../../modules';
import { Gate } from '../../controls/Gate';

interface IListParametersProps extends IListProps {
  parametercategoryId?: number;
  /**
   * Event is fired when a parameter is clicked.
   */
  onClick?: (parameter:Parameter) => void;
}

interface IListParametersState extends IListState<Parameter> {
}

class ListParameters extends List<Parameter, IListParametersProps, IListParametersState> {
  constructor(props: IListParametersProps) {
    super(props, ParameterFactory, 'name', 'asc');

    // Initialize state (list initializes its own part of the state):
    this.state = {
      ...this.state
    };

    if(this.props.parametercategoryId) {
      this.setFilter('parametercategory', 'eq', { id: this.props.parametercategoryId }, true);
    }      
  }

  handleSearch = (value:string) => {
    this.setFilter('q', 'like', value);
  }

  render() {
    let p = this.props;

    let filter = 
    <React.Fragment>
      <Panel.Content>
        <Form.Uncontrolled hint="Type to search records">
          <SearchFilter value={this.getFilter('q', 'like')} onSearch={this.handleSearch}/>
        </Form.Uncontrolled>
      </Panel.Content>
      <Panel.Footer>
        <div style={{display: "flex", justifyContent: 'space-between'}}>
          <Gate right='can_delete_parameters'>
            <Form.Uncontrolled>
              <Checkbox label="Include deleted items" name="trash" type="toggle" checked={this.getTrash()} onChange={this.handleTrash}/>
            </Form.Uncontrolled>
          </Gate>
          <Export onExport={this.handleExport}/>
        </div>
      </Panel.Footer>      
    </React.Fragment>
    
    return (
      <React.Fragment>
        <IconBar>
          <Panel.Icon icon="tools" width={300}>
            {filter}
          </Panel.Icon>
        </IconBar>           
        <DataTable error={this.state.error} loading={this.state.loading} scrollTop={this.state.scrollTop} onScroll={this.handleScroll} data={this.state.items} onFetch={this.handleFetch} onClick={p.onClick} onOrder={this.handleOrder} order={this.getOrder()} dir={this.getDir()}>
          <DataTable.Column weight={3} label="Name" order="name" dir="asc">{(item:Parameter) => item.name}</DataTable.Column>
          <DataTable.Column weight={1} label="Unit" order="unit" dir="asc">{(item:Parameter) => item.unit}</DataTable.Column>
        </DataTable>
        <Dialog.Xhr open={this.state.exportError != null} error={this.state.exportError} onClose={this.handleCloseDialog}/>
      </React.Fragment>
    );
  }
}

export { ListParameters };
